<div class="row">
  <div class="col-lg-5 left-content">
    <div class="d-flex justify-content-between flex-row flex-wrap">
      <div>
        <h5 class="font-weight-bold">IVT</h5>
        <h3 *ngIf="!isFreemium || (isFreemium && isFollowing)"
            class="mb-4 font-weight-bold ivt-value">
          {{data?.ivtDistribution?.givtSivtRate | perc:'1.2-2'}}
        </h3>
        <ng-container *ngIf="isFreemium && !isFollowing">
          <div class="freemium-lock ml-3">
            <i class="fa fa-lock"></i>
          </div>
        </ng-container>
      </div>
      <div>
        <h5 class="font-weight-bold">GIVT</h5>
        <h3 *ngIf="!isFreemium" class="mb-4 font-weight-bold ivt-value">
          {{data?.ivtDistribution?.givtRate | perc:'1.2-2'}}
        </h3>
        <ng-container *ngIf="isFreemium">
          <div class="freemium-lock ml-3">
            <i class="fa fa-lock"></i>
          </div>
        </ng-container>
      </div>
      <div>
        <h5 class="font-weight-bold">SIVT</h5>
        <h3 *ngIf="!isFreemium" class="mb-4 font-weight-bold ivt-value">
          {{data?.ivtDistribution?.sivtRate | perc:'1.2-2'}}
        </h3>
        <ng-container *ngIf="isFreemium">
          <div class="freemium-lock ml-3">
            <i class="fa fa-lock"></i>
          </div>
        </ng-container>
      </div>
    </div>
    <ng-container *ngIf="!isFreemium">
      <app-bar-chart [data]="barChartData"
                     [categoryField]="'month'"
                     [valueFields]="['givtRate', 'sivtRate']"
                     [titleArray]="['GIVT', 'SIVT']"
                     [height]="'300px'"
                     [type]="'double'"></app-bar-chart>
    </ng-container>
  </div>
  <div class="col-lg-7">
    <ng-container *ngIf="sellers?.length > 0">
      <h5 class="font-weight-bold">Authorized Seller (Ads.txt) Share of Voice</h5>
      <div class="row">
        <div class="col-4 hidden-md-down"></div>
        <div class="col-5 font-weight-bold">INVENTORY</div>
        <div class="col">
          <div class="row">
            <div class="col"></div>
            <div class="col font-weight-bold">IVT</div>
          </div>
        </div>
      </div>
      <div class="row" *ngFor="let seller of sellers">
        <div class="col-4 white-space-nowrap text-overflow-ellipsis overflow-hidden hidden-md-down">
          <img
            src="https://cdn.pixalate.com/sellers/icons/apn/16x16/{{seller?.sellerId}}.jpg"  width="16" height="16" alt="Seller Icon"/> {{seller?.sellerName}}
          ({{seller?.paymentType === 'N/A' ? 'Unauthorized' : seller?.paymentType}})
        </div>
        <div class="col-5 overflow-hidden">
          <div class="progress rounded-0 position-relative overflow-hidden">
            <div class="progress-bar" role="progressbar" [ngStyle]="{width: seller?.styleWidth}" aria-valuenow="25"
                 aria-valuemin="0"
                 aria-valuemax="100"></div>
            <span class="text-left text-white white-space-nowrap overflow-hidden text-overflow-ellipsis hidden-lg-up"
                  style="position: absolute; text-shadow: 1px 1px #000000; left: 0; right: 0;">
              {{seller?.sellerName}}({{seller?.paymentType === 'N/A' ? 'Unauthorized' : seller?.paymentType}})</span>
          </div>
        </div>
        <div class="col">
          <div class="row">
            <ng-container *ngIf="!isFreemium">
              <div class="col">
                {{seller?.totalTrafficRatio | perc : '1.2-2'}}
              </div>
              <div class="col" *ngIf="seller?.givtSivtRate > 0">
                {{seller?.givtSivtRate | perc : '1.2-2'}}
              </div>
              <div class="col" *ngIf="seller?.givtSivtRate <= 0">
                00.00%
              </div>
            </ng-container>
            <ng-container *ngIf="isFreemium">
              <div class="col">
                <div class="freemium-lock">
                  <i class="fa fa-lock"></i>
                </div>
              </div>
              <div class="col">
                <div class="freemium-lock">
                  <i class="fa fa-lock"></i>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="trafficSources?.length > 0">
      <h5 class="font-weight-bold mt-3">Referral Traffic</h5>
      <div class="row">
        <div class="col-4 hidden-md-down"></div>
        <div class="col-5 font-weight-bold">CONTRIBUTION</div>
        <div class="col font-weight-bold">
          <div class="row">
            <div class="col"></div>
            <div class="col">IVT</div>
          </div>
        </div>
      </div>
      <div class="row" *ngFor="let trafficSource of trafficSources">
        <div class="col-4 hidden-md-down">{{trafficSource?.trafficSource}}</div>
        <div class="col-5 ">
          <div class="progress rounded-0">
            <div class="progress-bar" role="progressbar" [ngStyle]="{width: trafficSource?.styleWidth}"
                 aria-valuenow="25" aria-valuemin="0"
                 aria-valuemax="100"></div>

            <span class="text-white hidden-lg-up" style="position: absolute; text-shadow: 1px 1px #000000;">{{trafficSource?.trafficSource}}</span>
          </div>
        </div>
        <div class="col">
          <div class="row">
            <ng-container *ngIf="!isFreemium">
              <div class="col">{{trafficSource?.totalTrafficRatio | perc : '1.2-2'}}</div>
              <div class="col"
                   *ngIf="trafficSource?.givtSivtRate > 0">{{trafficSource?.givtSivtRate | perc : '1.2-2'}}</div>
              <div class="col" *ngIf="trafficSource?.givtSivtRate <= 0">00.00%</div>
            </ng-container>
            <ng-container *ngIf="isFreemium">
              <div class="col">
                <div class="freemium-lock">
                  <i class="fa fa-lock"></i>
                </div>
              </div>
              <div class="col">
                <div class="freemium-lock">
                  <i class="fa fa-lock"></i>
                </div>
              </div>
            </ng-container>
          </div>
        </div>

      </div>
    </ng-container>
    <ng-container *ngIf="deviceTypes && deviceTypes?.length > 0 && deviceTypes[0]?.totalTrafficRatio">
      <h5 class="font-weight-bold mt-3">Device Distribution</h5>
      <div class="row">
        <div class="col-4 hidden-md-down"></div>
        <div class="col-5 font-weight-bold">CONTRIBUTION</div>
        <div class="col">
          <div class="row">
            <div class="col"></div>
            <div class="col font-weight-bold">IVT</div>
          </div>
        </div>
      </div>
      <div class="row" *ngFor="let deviceType of deviceTypes">
        <div class="col-4 text-capitalize hidden-md-down">{{deviceType?.deviceType}}</div>
        <div class="col-5">
          <div class="progress rounded-0">
            <div class="progress-bar" role="progressbar" [ngStyle]="{width: deviceType?.styleWidth}"
                 aria-valuenow="25" aria-valuemin="0"
                 aria-valuemax="100">
            </div>
            <span class="text-white hidden-lg-up" style="position: absolute; text-shadow: 1px 1px #000000;">{{deviceType?.deviceType}}</span>
          </div>
        </div>
        <div class="col">
          <div class="row">
            <ng-container *ngIf="!isFreemium">
              <div class="col">{{deviceType?.totalTrafficRatio | perc : '1.2-2'}}</div>
              <div class="col"
                   *ngIf="deviceType?.givtSivtRate > 0">{{deviceType?.givtSivtRate | perc : '1.2-2'}}</div>
              <div class="col" *ngIf="deviceType?.givtSivtRate <= 0">00.00%</div>
            </ng-container>
            <ng-container *ngIf="isFreemium">
              <div class="col">
                <div class="freemium-lock">
                  <i class="fa fa-lock"></i>
                </div>
              </div>
              <div class="col">
                <div class="freemium-lock">
                  <i class="fa fa-lock"></i>
                </div>
              </div>
            </ng-container>
          </div>
        </div>

      </div>
    </ng-container>
  </div>
</div>
